import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';


// worker Saga: will be fired on REQUEST_SEND_TO_SPECIAL_SERVICE actions
function* sendToSpecialService(action) {
   try {
      const result = yield call(axios.post, '/api/special_services/send', action.payload);
      yield put({type: "REQUEST_SEND_TO_SPECIAL_SERVICE_SUCCESS", result});
   } catch (error) {
      yield put({type:'SET_SNACKBAR', val:{open:true, message:'Make sure you have enough credits to complete this operation.', type:'error'}});
   }
}

/*
  Starts sendToSpecialService on each dispatched `REQUEST_SEND_TO_SPECIAL_SERVICE` action.
  Allows concurrent requests to be made.
*/
function* Send_to_special_services() {yield takeEvery("REQUEST_SEND_TO_SPECIAL_SERVICE", sendToSpecialService);}

export default function* Root_special_services(){
  yield all([
    fork(Send_to_special_services)
  ]);}
